module.exports = __webpack_public_path__ + "images/d8b422387621937d8d234f6f3ea126d9.jpg";